<template>
  <div class="interviewRegistration_page">
    <div class="interviewRegistration">
      <h1 class="hh1">深圳晨星</h1>
      <div class="contain">
        <div class="conhd"><img src="../../assets/images/ypbg.png" />应聘登记</div>
        <el-form ref="form" :rules="rules" :model="formData" label-width="10.8rem">
          <el-form-item label="姓名:" prop="pername">
            <el-input v-model="formData.pername"></el-input>
          </el-form-item>
          <el-form-item label="联系方式:" prop="contact">
            <el-input v-model="formData.contact"></el-input>
          </el-form-item>
          <el-form-item label="性别:" prop="sex">
            <el-radio-group v-model="formData.sex">
              <el-radio label="男"></el-radio>
              <el-radio label="女"></el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="应聘岗位:" prop="gangwei">
            <el-input v-model="formData.gangwei"></el-input>
          </el-form-item>
          <el-form-item label="邀约人:" prop="invitePeople">
            <el-input v-model="formData.invitePeople"></el-input>
          </el-form-item>
          <el-form-item label="信息来源:" prop="source">
            <el-select v-model="formData.source" placeholder="请选择">
              <el-option value="">请选择</el-option>
              <el-option label="前程无忧" value="前程无忧"></el-option>
              <el-option label="智联招聘" value="智联招聘"></el-option>
              <el-option label="58同城" value="58同城"></el-option>
              <el-option label="BOSS直聘" value="BOSS直聘"></el-option>
              <el-option label="QQ群" value="QQ群"></el-option>
              <el-option label="朋友推荐" value="朋友推荐"></el-option>
              <el-option label="拉勾网" value="拉勾网"></el-option>
              <el-option label="其他" value="其他"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="upload" label="简历:" prop="pics">
            <el-upload :action="uploadUrl" list-type="picture-card" :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload" :on-preview="handlePictureCardPreview" :on-remove="handleRemove">
              <i class="el-icon-plus"></i>
            </el-upload>
            <el-dialog :visible.sync="dialogVisible">
              <img width="100%" :src="dialogImageUrl" alt="" />
            </el-dialog>
          </el-form-item>
          <!-- <el-form-item class="upload" label="健康码/行程码:">
            <el-upload class="annaul-ticket-imgs" :on-change="handleEditChange" :class="{ 'hide-upload-btn': hideUploadBtn }" :action="uploadUrl2" :limit="2" list-type="picture-card" :on-success="handleAvatarSuccess2" :before-upload="beforeAvatarUpload" :on-preview="handlePictureCardPreview" :on-remove="handleRemove2">
              <i class="el-icon-plus"></i>
            </el-upload>
            <el-dialog :visible.sync="dialogVisible">
              <img width="100%" :src="dialogImageUrl" alt="" />
            </el-dialog>
          </el-form-item> -->
        </el-form>

        <el-button @click="seve()" class="divtj" type="">确认提交</el-button>
      </div>
    </div>
  </div>
</template>

<script>
  import { interviewRegistration } from '@/api/common.js'

  export default {
    name: 'interviewRegistration',
    data() {
      return {
        formData: {
          pername: '',
          contact: '',
          sex: '男',
          gangwei: '',
          invitePeople: '',
          source: '',
          pics: [],
          jkm: [],
        },
        did: '',
        dialogImageUrl: '',
        dialogVisible: false,
        hideUploadBtn: false,
        uploadUrl: '',
        uploadUrl2: '',
        rules: {
          pername: [{ required: true, message: '姓名不能为空', trigger: 'blur' }],
          sex: [{ required: true, message: '性别不能为空', trigger: 'blur' }],
          contact: [
            { required: true, message: '联系方式不能为空', trigger: 'blur' },
            { pattern: /^1\d{10}$/, message: '请输入正确的手机号', trigger: 'blur' },
          ],
          gangwei: [{ required: true, message: '应聘岗位不能为空', trigger: 'blur' }],
          invitePeople: [{ required: true, message: '邀约人不能为空', trigger: 'blur' }],
          source: [{ required: true, message: '信息来源不能为空', trigger: 'blur' }],
          pics: [{ required: true, message: '简历不能为空' }],
        },
      }
    },
    created() {
      // 获取上传url
      this.uploadUrl = process.env.VUE_APP_API_URL + '/Data/do_datapost_kuayu/loaddail?ty=hr'
      this.uploadUrl2 = process.env.VUE_APP_API_URL + '/Data/do_datapost_kuayu/loaddail?ty=jkm'
      if (window.location.pathname === '/interviewRegistration') {
        import('@/assets/css/rem.less')
      }
      // 从路由中获取参数
      let params = this.$route.query
      console.log('params: ', params)
      if (params) {
        this.did = params.did || 1
      } else {
        this.did = 1
      }
    },
    methods: {
      seve() {
        this.$refs['form'].validate(async (valid) => {
          if (!valid) return
          let formData = this.formData
          if (!Array.isArray(formData.pics) || formData.pics.length === 0) {
            this.$message.error('请上传简历')
            return
          }
          formData.did = this.did
          let res = await interviewRegistration(formData)
          if (res.status !== 200) return this.$message.error(res.msg)
          this.$message.success('提交成功')
        })
      },
      handleRemove(file, fileList) {
        const removeUrl = file.response.url
        this.formData.pics = this.formData.pics.filter((v) => v.indexOf(removeUrl) === -1)
      },
      handlePictureCardPreview(file) {
        console.log(file)
        this.dialogImageUrl = file.url
        this.dialogVisible = true
      },
      // 上传图片
      handleAvatarSuccess(res, file) {
        if (res.status !== 200) return this.$message.error('上传失败')
        this.$message.success('上传成功')
        this.formData.pics.push('http://yjhr.oss-cn-shenzhen.aliyuncs.com/' + res.url)
      },
      handleRemove2(file, fileList) {
        const removeUrl = file.response.url
        this.formData.jkm = this.formData.jkm.filter((v) => v.indexOf(removeUrl) === -1)
        this.hideUploadBtn = fileList.length >= 2
      },
      // 上传图片
      handleAvatarSuccess2(res, file) {
        if (res.status !== 200) return this.$message.error('上传失败')
        this.$message.success('上传成功')
        this.formData.jkm.push('http://yjhr.oss-cn-shenzhen.aliyuncs.com/' + res.url)
      },
      // 上传限制
      beforeAvatarUpload(file) {
        const allowedTypes = ['image/jpeg', 'image/png']
        const isLt5M = file.size / 1024 / 1024 < 5
        if (!allowedTypes.includes(file.type)) {
          this.$message.error('上传图片只能是 JPG/PNG 格式!')
        }
        if (!isLt5M) {
          this.$message.error('上传图片大小不能超过 5MB!')
        }
        return allowedTypes.includes(file.type) && isLt5M
      },

      handleEditChange(file, fileList) {
        this.hideUploadBtn = fileList.length >= 2
      },
    },
  }
</script>

<style lang="less">
  .interviewRegistration_page {
    background-color: #2c7ae5;
    max-width: 350rem;
  }
  .interviewRegistration {
    padding-bottom: 1rem;

    .hh1 {
      width: 100%;
      text-align: center;
      color: #fff;
      font-size: 2rem;
      padding-top: 2rem;
      line-height: 3rem;
      font-weight: normal;
      margin-top: 0;
    }
    .contain {
      width: 96%;
      margin: 20px auto;
      background: #fff;
      border-radius: 0.5rem;
      padding-bottom: 1rem;
      box-sizing: border-box;
    }
    .conhd {
      width: 100%;
      font-size: 1.5rem;
      line-height: 1.8rem;
      color: #2c7ae5;
      padding-top: 1.5rem;
      display: flex;
      align-items: center;
      margin-bottom: 1rem;
      img {
        width: 1.45rem;
        margin-right: 0.5rem;
        margin-left: 1rem;
        vertical-align: middle;
      }
    }
    .el-form {
      padding-right: 3.5rem;
    }
    .el-form-item {
      display: flex;
      align-items: center;
      margin-bottom: 1rem;
      .el-form-item__content,
      .el-input__icon,
      .el-form-item__label {
        line-height: 2rem;
      }
      .el-form-item__error {
        font-size: 0.6rem;
        padding-top: 0.2rem;
      }

      &.upload {
        .annaul-ticket-imgs {
          &.hide-upload-btn {
            .el-upload--picture-card {
              display: none;
            }
          }
        }
        .el-form-item__content > div {
          display: flex;
          flex-flow: wrap;
        }
      }
      .el-form-item__content {
        margin-left: 0 !important;
        flex: 1;
      }
      .el-date-editor {
        .el-input__inner {
          padding-left: 0.75rem;
        }
      }
      .el-input__inner {
        padding-left: 0.75rem;
        height: 2.5rem;
        border: 1px solid #d3d3d3;
        border-radius: 0.2rem;
        font-size: 1.2rem;
        width: 21.7rem;
      }
      .el-form-item__label {
        padding-left: 0.06rem;

        color: #333;
        font-size: 1.2rem;
      }
      .el-radio__label {
        font-size: 1.2rem;
      }
      .el-radio__inner {
        width: 1.2rem;
        height: 1.2rem;
        &::after {
          width: 0.5rem;
          height: 0.5rem;
        }
      }
      .el-upload-list--picture-card .el-upload-list__item,
      .el-upload--picture-card {
        width: 6.94rem;
        height: 5rem;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .el-upload-list {
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex-wrap: wrap;
        li {
          margin-right: 0.4rem;
        }
        li:nth-of-type(3n) {
          margin-right: 0;
        }
      }
    }
    .divtj {
      margin: 0px auto;
      width: 93.5%;
      font-size: 1.6rem;
      text-align: center;
      line-height: 3.5rem;
      color: #fff;
      background: #2c7ae5;
      border-radius: 0.3rem;
      display: block;
      margin-bottom: 1rem;
    }
  }
</style>
